import * as mt from './mutation-types';

import { RootState } from '../types';
import { WeatherPayload, WeatherState } from './types';
import { ActionContext } from 'vuex';

type WeatherContext = ActionContext<WeatherState, RootState>;

export default {
  // TEMPERATURE
  [mt.CLEANUP_TEMPERATURE]({ commit }: WeatherContext) {
    commit(mt.CLEANUP_TEMPERATURE);
  },

  [mt.FETCHING_CURRENT_TEMPERATURE_AVERAGE]({ commit }: WeatherContext, cacheKey: string) {
    commit(mt.FETCHING_CURRENT_TEMPERATURE_AVERAGE, { cacheKey });
  },
  [mt.FETCH_CURRENT_TEMPERATURE_AVERAGE]({ commit }: WeatherContext, payload: WeatherPayload) {
    commit(mt.FETCH_CURRENT_TEMPERATURE_AVERAGE, payload);
  },
  [mt.FETCH_CURRENT_TEMPERATURE_FAILURE]({ commit }: WeatherContext, cacheKey: string) {
    commit(mt.FETCH_CURRENT_TEMPERATURE_FAILURE, { cacheKey });
  },

  [mt.FETCHING_PERIOD_TEMPERATURE_AVERAGE]({ commit }: WeatherContext, cacheKey: string) {
    commit(mt.FETCHING_PERIOD_TEMPERATURE_AVERAGE, { cacheKey });
  },
  [mt.FETCH_PERIOD_TEMPERATURE_AVERAGE]({ commit }: WeatherContext, payload: WeatherPayload) {
    commit(mt.FETCH_PERIOD_TEMPERATURE_AVERAGE, payload);
  },
  [mt.FETCH_PERIOD_TEMPERATURE_FAILURE]({ commit }: WeatherContext, cacheKey: string) {
    commit(mt.FETCH_PERIOD_TEMPERATURE_FAILURE, { cacheKey });
  },

  [mt.FETCHING_HISTORICAL_TEMPERATURE_AVERAGE]({ commit }: WeatherContext, cacheKey: string) {
    commit(mt.FETCHING_HISTORICAL_TEMPERATURE_AVERAGE, { cacheKey });
  },
  [mt.FETCH_HISTORICAL_TEMPERATURE_AVERAGE]({ commit }: WeatherContext, payload: WeatherPayload) {
    commit(mt.FETCH_HISTORICAL_TEMPERATURE_AVERAGE, payload);
  },
  [mt.FETCH_HISTORICAL_TEMPERATURE_FAILURE]({ commit }: WeatherContext, cacheKey: string) {
    commit(mt.FETCH_HISTORICAL_TEMPERATURE_FAILURE, { cacheKey });
  },

  // SPI-4
  [mt.CLEANUP_SPI4]({ commit }: WeatherContext) {
    commit(mt.CLEANUP_SPI4);
  },

  [mt.FETCHING_CURRENT_SPI4_AVERAGE]({ commit }: WeatherContext, cacheKey: string) {
    commit(mt.FETCHING_CURRENT_SPI4_AVERAGE, { cacheKey });
  },
  [mt.FETCH_CURRENT_SPI4_AVERAGE]({ commit }: WeatherContext, payload: WeatherPayload) {
    commit(mt.FETCH_CURRENT_SPI4_AVERAGE, payload);
  },
  [mt.FETCH_CURRENT_SPI4_FAILURE]({ commit }: WeatherContext, cacheKey: string) {
    commit(mt.FETCH_CURRENT_SPI4_FAILURE, { cacheKey });
  },

  [mt.FETCHING_PERIOD_SPI4_AVERAGE]({ commit }: WeatherContext, cacheKey: string) {
    commit(mt.FETCHING_PERIOD_SPI4_AVERAGE, { cacheKey });
  },
  [mt.FETCH_PERIOD_SPI4_AVERAGE]({ commit }: WeatherContext, payload: WeatherPayload) {
    commit(mt.FETCH_PERIOD_SPI4_AVERAGE, payload);
  },
  [mt.FETCH_PERIOD_SPI4_FAILURE]({ commit }: WeatherContext, cacheKey: string) {
    commit(mt.FETCH_PERIOD_SPI4_FAILURE, { cacheKey });
  },

  [mt.FETCHING_HISTORICAL_SPI4_AVERAGE]({ commit }: WeatherContext, cacheKey: string) {
    commit(mt.FETCHING_HISTORICAL_SPI4_AVERAGE, { cacheKey });
  },
  [mt.FETCH_HISTORICAL_SPI4_AVERAGE]({ commit }: WeatherContext, payload: WeatherPayload) {
    commit(mt.FETCH_HISTORICAL_SPI4_AVERAGE, payload);
  },
  [mt.FETCH_HISTORICAL_SPI4_FAILURE]({ commit }: WeatherContext, cacheKey: string) {
    commit(mt.FETCH_HISTORICAL_SPI4_FAILURE, { cacheKey });
  },
  
};
